export const foodCategoryColors = [{'category':'Meat','color':'#DC4D2E'},{'category':'Vegetarian','color':'#A1C277'},
{'category':'Vegan','color':'#8DC9CD'},{'category':'Gluten Free','color':'#EE9F29'},
{'category':'Fish','color':'#009ddc'}]